import classNames from 'classnames';
import { PropsWithChildren, ReactNode } from 'react';
import styled from 'styled-components';

import { SBHorizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';

import bg from './assets/bg.jpg';

const Root = styled(Vertical).attrs({ gap: 0 })`
  overflow: hidden;
  border: 1.5px solid transparent;
  border-radius: var(--double-unit);
  padding: var(--double-unit) var(--double-unit) 0 var(--double-unit);
  background:
    no-repeat center / cover url(${bg}) padding-box,
    var(--c-green-400) border-box;

  &.disabled {
    background:
      linear-gradient(to bottom, var(--c-nl-600), var(--c-nl-600)) border-box,
      no-repeat center / cover url(${bg}) padding-box,
      var(--c-green-400) border-box;
  }
  transition: 300ms opacity ease-in-out;
`;
const Header = styled(SBHorizontal)`
  width: 100%;
  align-self: stretch;
`;

type Props = {
  disabled?: boolean;
  topLeft?: ReactNode;
  topRight?: ReactNode;
  footer?: ReactNode;
};
export const CategoryTile = ({
  disabled,
  topLeft,
  topRight,
  footer,
  children,
}: PropsWithChildren<Props>) => {
  return (
    <Root className={classNames({ disabled })}>
      <Header>
        <div>{topLeft}</div>
        <div>{topRight}</div>
      </Header>
      <Vertical center gap={3}>
        {children}
        {footer}
      </Vertical>
    </Root>
  );
};
